var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"author-icon",style:({'border': ("1px solid " + _vm.color)})},[_c('div',{staticClass:"icon-small",style:({'border': ("1px solid " + _vm.color)})})])}
var staticRenderFns = []

export { render, staticRenderFns }